(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apply-business"] && !window.DesignMode) return;
  try {
    
  
  
jQuery(document).ready(function () {
  jQuery('.accordion-button').on('click', function () {
    const $body = jQuery(this).closest('.accordion-item').find('.accordion-body');

    // Toggle the current accordion body
    $body.slideToggle();

    // Close other accordion bodies
    jQuery('.accordion-body').not($body).slideUp();

    // Toggle active class for arrow rotation
    jQuery(this).toggleClass('active');
    jQuery('.accordion-button').not(this).removeClass('active');
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cost-ownership"] && !window.DesignMode) return;
  try {
    

	$(document).ready(function () {
    // Function to animate the counter
    function animateCounter(element) {
        const target = parseInt($(element).data('target')); // Get the target number
        let count = 0;
        const increment = Math.ceil(target / 100); // Adjust speed here
        const duration = 2000; // Animation duration in milliseconds
        const stepTime = duration / (target / increment);

        const interval = setInterval(() => {
            count += increment;
            if (count >= target) {
                count = target;
                clearInterval(interval);
            }
            $(element).text(count);
        }, stepTime);
    }

    // Check if an element is in the viewport
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    // Watch for scrolling
    $(window).on('scroll', function () {
        $('.counter').each(function () {
            if (isInViewport(this) && !$(this).hasClass('counted')) {
                $(this).addClass('counted'); // Ensure it doesn't animate again
                animateCounter(this);
            }
        });
    });

    // Trigger scroll event on page load to catch elements already in view
    $(window).trigger('scroll');
});


  } catch(e) { console.error(e); }
})();
})();
